<template>
  <nt-auth-template>
    <v-row dense align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card color="loginBackground">
          <v-card-text class="text-center">
            <img class="my-3" :src="info.app_logo"/>
            <h3 class="text-h5 mt-4 mb-0">Primeiro Acesso (Verificação)</h3>
          </v-card-text>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <v-form @submit.prevent="submit()" method="post" id="verification">
                  <v-text-field
                    name="enrollment"
                    label="Matrícula"
                    v-model="user.enrollment"
                    required
                    prepend-icon="mdi-account"
                    type="text"
                    :error="error.error"
                    :error-messages="error.messages"
                    :autofocus="focusUsernameInput"
                    color="loginFont"/>
                  <v-text-field
                    v-model="user.birth_date"
                    v-mask="'##/##/####'"
                    label="Data de Nascimento"
                    hint="DD/MM/YYYY"
                    persistent-hint
                    prepend-icon="mdi-cake"
                    color="loginFont"/>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn text exact :to="{ name: 'auth.login' }">Cancelar</v-btn>
            <v-spacer/>
            <v-btn exact type="submit" form="verification" color="loginButton">Verificar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </nt-auth-template>
</template>

<script>
import store from '@/store'
import { mapGetters } from 'vuex'
import NtAuthTemplate from '@/components/Utils/NtAuthTemplate'

export default {
  components: {
    NtAuthTemplate
  },
  mounted () {
    if (this.isAuthenticated) {
      this.$router.push({ name: 'ambienteAluno.dashboard' })
    }
  },
  data () {
    return {
      user: {
        enrollment: '',
        birth_date: ''
      },
      error: {
        error: false,
        messages: []
      },
      menu: false,
      passVisibility: false
    }
  },
  methods: {
    submit () {
      this.user.birth_date = this.user.birth_date.replace(/\D+/g, '')

      this.error.error = false
      this.error.messages = []
      store.dispatch('App/firstAccessVerify', this.user)
        .then(() => {
          this.$router.push({ name: 'auth.firstAccess.register' })
        })
        .catch((error) => {
          this.error.error = true
          this.user.birth_date = ''
          this.user.enrollment = ''
          switch (error.status) {
            case 422:
              this.error.messages = error.data
              break
            case 412:
            case 404:
              this.$toasted.error(error.data.message)
              break
            default:
              this.$toasted.error(error.statusText)
              break
          }
        })
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'App/isAuthenticated',
      info: ['App/info']
    }),
    focusUsernameInput () {
      return this.user.enrollment === ''
    }
  }
}
</script>
